import { render, staticRenderFns } from "./LeadsGridHeadline.vue?vue&type=template&id=1ac62e75"
import script from "./LeadsGridHeadline.vue?vue&type=script&lang=ts"
export * from "./LeadsGridHeadline.vue?vue&type=script&lang=ts"
import style0 from "./LeadsGridHeadline.vue?vue&type=style&index=0&id=1ac62e75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports